import styled from 'styled-components'
import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { Spacings, Text, Devices } from '@styles'

export const FormBody = styled(DrawerBodyWrapper)`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
`

export const FormFooter = styled(DrawerFooterWrapper)`
	gap: ${Spacings.SPACING_3B};
`

export const FormSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
`

export const FormRow = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_4B};

	& > * {
		flex: 1;
		min-width: 0;
	}

	@media ${Devices.mobile} {
		flex-direction: column;
	}
`

export const SectionLabel = styled.label`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};

	& > span {
		color: ${({ theme }) => theme.palette.background.red};
		margin-left: ${Spacings.SPACING_1};
	}
`
